import { IColumn, IDetailsColumnStyles } from '@fluentui/react';
import { centerAlignHeaderStyle, rightAlignHeaderStyle } from 'common/utils/columnUtilities';

export const columns: IColumn[] = [
  {
    key: 'fileReference',
    name: 'File',
    fieldName: 'fileReference',
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: 'indexName',
    name: 'Name',
    fieldName: 'indexName',
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: '_documentContents',
    name: 'Description',
    fieldName: '_documentContents',
    minWidth: 120,
    maxWidth: 140,
    isResizable: true,
  },
  {
    key: 'indexReferenceNumber',
    name: 'Number',
    fieldName: 'indexReferenceNumber',
    minWidth: 160,
    maxWidth: 240,
    isResizable: true,
  },
  {
    key: 'amount',
    name: 'Amount',
    fieldName: 'amount',
    minWidth: 110,
    maxWidth: 130,
    isResizable: true,
    styles: rightAlignHeaderStyle,
  },
  {
    key: 'action',
    name: 'Action',
    fieldName: 'action',
    minWidth: 80,
    maxWidth: 80,
    isResizable: false,
    styles: centerAlignHeaderStyle,
  },
];
